
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SidebarHeaderProps {
  diagramName?: string;
  onBack: () => void;
}

export function SidebarHeader({ diagramName, onBack }: SidebarHeaderProps) {
  return (
    <div className="p-4">
      <div className="flex items-center justify-start mb-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="h-6 text-sidebar-foreground hover:bg-sidebar-accent flex items-center gap-1 px-2"
        >
          <ArrowLeft className="h-3 w-3" />
          <span className="text-xs">Voltar</span>
        </Button>
      </div>
      {diagramName && (
        <h1 className="text-lg font-bold text-sidebar-foreground mb-3 truncate" title={diagramName}>
          {diagramName}
        </h1>
      )}
    </div>
  );
}
